import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';

const workoutExerciseApi = createApi({
  reducerPath: 'workoutExercises',
  tagTypes: ['WorkoutExercise'],
  baseQuery,
  endpoints(builder) {
    return {
      fetchWorkoutsExercises: builder.query({
        providesTags: (result) =>
          result
            ? [
                { type: 'WorkoutExercise', id: 'LIST' },
                ...result.map((r) => ({ type: 'WorkoutExercise', id: r.id })),
              ]
            : [{ type: 'WorkoutExercise', id: 'LIST' }],
        query: () => ({
          url: `?resource=workout_exercise`,
          method: 'GET',
        }),
      }),

      createWorkoutExercise: builder.mutation({
        // Invalida la lista de workout_exercises y el workout que los contiene
        invalidatesTags: [
          { type: 'WorkoutExercise', id: 'LIST' },
          { type: 'Workout', id: 'LIST' },
        ],
        query: (data) => ({
          url: `?resource=workout_exercise`,
          method: 'POST',
          body: data,
          headers: {
            Prefer: 'return=representation',
            'Content-Type': 'application/json',
          },
        }),
      }),

      updateWorkoutExercise: builder.mutation({
        invalidatesTags: (result, error, { id: workoutExerciseId }) => [
          { type: 'WorkoutExercise', id: workoutExerciseId },
          { type: 'Workout', id: 'LIST' },
        ],
        query: ({ id: workoutId, submitData }) => ({
          url: `?resource=workout_exercise&id=eq.${workoutId}`,
          method: 'PATCH',
          body: submitData,
          headers: {
            'Content-Type': 'application/json',
          },
        }),
      }),

      deleteWorkoutExercise: builder.mutation({
        invalidatesTags: (result, error, workoutExerciseId) => [
          { type: 'WorkoutExercise', id: workoutExerciseId },
          { type: 'WorkoutExercise', id: 'LIST' },
          { type: 'Workout', id: 'LIST' },
        ],
        query: (workoutId) => ({
          url: `?resource=workout_exercise&id=eq.${workoutId}`,
          method: 'DELETE',
        }),
      }),

      fetchWorkoutExercise: builder.query({
        providesTags: (result, error, arg) => [{ type: 'WorkoutExercise', id: arg }],
        query: (workoutId) => ({
          url: `?resource=workout_exercise&id=eq.${workoutId}`,
          method: 'GET',
        }),
      }),

      fetchWorkoutsWithExercise: builder.query({
        providesTags: (result) =>
          result
            ? [
                { type: 'WorkoutExercise', id: 'LIST' },
                ...result.map((r) => ({ type: 'WorkoutExercise', id: r.id })),
              ]
            : [{ type: 'WorkoutExercise', id: 'LIST' }],
        query: (exerciseId) => ({
          url: `?resource=workout_exercise&exercise=eq.${exerciseId}&select=*,workout(*,program(name))`,
          method: 'GET',
        }),
      }),
    };
  },
});

export const {
  useFetchWorkoutsExercisesQuery,
  useCreateWorkoutExerciseMutation,
  useUpdateWorkoutExerciseMutation,
  useDeleteWorkoutExerciseMutation,
  useFetchWorkoutExerciseQuery,
  useFetchWorkoutsWithExerciseQuery,
} = workoutExerciseApi;

export { workoutExerciseApi };
